import React from "react";
import { useSelector } from "react-redux";
import { resolveBucketImageSrc } from "../../../../utils/utils";
import actionType from "../../../../enums/actionType";
import emptyScheduleImage from "../../../../../assests/schedule/EmptySchschedule.png";
import classes from "./ScheduleViewBody.module.css";

const ScheduleViewBody = ({ scheduleEntities, setMode, canEdit }) => {

    const { texts } = useSelector(state => state.translate);
    const viewEntity =scheduleEntities.find((entity) => !entity.nmmIds?.length) ?? scheduleEntities[0];
    
    const handleChangeImage = () => {
        setMode(actionType.edit);
    };

    return (
        <div className={classes.ViewBodyInner}>
            {viewEntity?.imageFile ?
                <div className={classes.ImagePreviewArea}>
                    <img className={classes.ScheduleImage} src={resolveBucketImageSrc(viewEntity?.imageFile)} alt="" />
                        {canEdit && 
                            <button className={classes.ChangeImageBtn} type="button" onClick={handleChangeImage}>
                            {texts.scheduleChangeImage}
                        </button>
                    }
                </div>
                :
                <div className={classes.EmptyPreview}>
                    <img src={emptyScheduleImage} alt="" />
                    <p className={classes.EmptyPreviewTitle}>{texts.scheduleNoClassSchedule}</p>
                    <p className={classes.EmptyPreviewDescription}>{texts.scheduleNoClassScheduleDescription}</p>
                </div>
            }
        </div>
    );
};
export default ScheduleViewBody;
